module.exports = __webpack_public_path__ + "img/logo-presse-ecran-mobile_200x200.c5ea0ff9.jpg";